import ShutdownSentry from './sentry';

const Shutdown = () => {
  ShutdownSentry();
};

export default Shutdown;
